import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Link from '../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function SectionTitle(props) {
  const { normalTitle, altTitle, alts, mixedTitle, id } = props

  let h1Props = {}

  if (id) {
    h1Props = { id }
  }

  return (
    <h1
      className="container"
      {...h1Props}
    >
      {mixedTitle ? (
        mixedTitle.split('|').map((text, i) => (
          <span
            key={text + i}
            className={i % 2 ? 'alt' : 'normal'}
          >
            {text}
          </span>
        ))
      ) : (
        <Fragment>
          <span className="normal">{`${normalTitle} `}</span>
          {alts ? (
            <span className="opener">
              <Link
                role="button"
                tabIndex={0}
                className="current"
              >
                <span className="alt">
                  {altTitle}
                </span>
              </Link>
              <div className="alt-list">
                {alts.map(({ altRoute, altRouteParams, altTitleItem }, index) => (
                  <Fragment key={altTitleItem + index}>
                    <Link
                      role="button"
                      tabIndex={0}
                      route={altRoute}
                      routeParams={altRouteParams}
                      className="alt-link"
                    >
                      <span className="label">{altTitleItem}</span>
                    </Link>
                  </Fragment>
                ))}
              </div>
            </span>
          ) : (
            <span className="alt">
              {altTitle}
            </span>
          )}
        </Fragment>
      )}
      <style jsx>{styles}</style>
    </h1>
  )
}

SectionTitle.propTypes = {
  normalTitle: PropTypes.string,
  altTitle: PropTypes.string,
  alts: PropTypes.arrayOf(
    PropTypes.shape({
      altTitleItem: PropTypes.string,
      altLink: PropTypes.string,
      altRoute: PropTypes.string,
      // eslint-disable-next-line
      altRouteParams: PropTypes.object,
    })
  ),
  mixedTitle: PropTypes.string,
  id: PropTypes.string,
}

SectionTitle.defaultProps = {
  normalTitle: '',
  altTitle: '',
  alts: null,
  mixedTitle: null,
  id: null,
}

SectionTitle = chainDecorators(decorators, SectionTitle)

export default SectionTitle
